/** @module store/branding */

/**
 * Simple store for branding specific issues.
 *
 * - `id` is the branding ID (or name) as used by the BE
 * - `apxLabel` is the label of the local energy manager
 *
 */
const state = () => ({
  id: '',
  apxLabel: '',
  mpgLabel: ''
})

const mutations = {
  SET_ID(state, id) {
    state.id = id
  },
  SET_APX_LABEL(state, label) {
    state.apxLabel = label
  },
  SET_MPG_LABEL(state, label) {
    state.mpgLabel = label
  }
}

export default {
  namespaced: true,
  state,
  mutations
}
